module.exports = __webpack_public_path__ + "linearIcons.65060723fe964f85afa0.woff";


//////////////////
// WEBPACK FOOTER
// /Users/abassey/side-proj/emp21-new/src/fonts/linearIcons.woff?w118d
// module id = ../../../../../src/fonts/linearIcons.woff?w118d
// module chunks = styles